import React from 'react'
import moment from 'moment'
import Modal from 'react-modal';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { browserHistory } from 'react-router'
import { adminUserAccounts } from '../../../core/controllers/Admin/AdminUserAccounts'
import { user } from '../../../core/controllers/user';
import { modal } from '../../../core/utilities/modal';
import { modalStyles } from '../../../core/controllers/ModalStyles';

export default class UsersTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userAccounts: null,
            showModal: false,
            exportType: ""
        };

        this.index = 0;
    }

    componentDidMount() {
        var self = this;
        adminUserAccounts.getUsers(function(response) {
            self.setState({
                userAccounts: response.data
            })
        });
    }

    componentWillUpdate(nextProps, nextState) {
    }

    logAsUser(account) {
        adminUserAccounts.loginAsUser(account.user_id, function(response) {
            modal.showInfo("Logging you into user.", "success", "top", "center");
            user.getUserData();
            window.location.href = '/';
        });
    }

    disableUser(account) {
        var self = this;
        adminUserAccounts.disableUser(account.user_id, function(response) {
            modal.showInfo("User account disabled.", "success", "top", "center");
            adminUserAccounts.getUsers(function(response) {
                self.setState({
                    userAccounts: response.data
                })
            });
        });
    }

    enableUser(account) {
        var self = this;
        adminUserAccounts.enableUser(account.user_id, function(response) {
            modal.showInfo("User account enabled.", "success", "top", "center");
            adminUserAccounts.getUsers(function(response) {
                self.setState({
                    userAccounts: response.data
                })
            });
        });
    }

    formatActionOptions(cell, row) {
        return (
        <span>
            <i class="pe-7s-mouse download-invoice" onClick={this.logAsUser.bind(this, row)}></i>
            { row.status == '2' ? (
                <i class="pe-7s-unlock download-invoice" onClick={this.enableUser.bind(this, row)}></i>
            ) : (
                <i class="pe-7s-lock download-invoice" onClick={this.disableUser.bind(this, row)}></i>
            )}
        </span>
        )
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatCompany(cell, row) {
        return row.company ? row.company : 'Not Set';
    }

    formatName(cell, row) {
        return row.firstname + ' ' + row.lastname;
    }

    formatUserType(cell, row) {
        return row.user_type;
    }

    formatBilling(cell, row) {
        var status = '<span class="important-small-red">Billing Needs Review</span>';
        if (row.accepts_payments == '1') {
            status = '<span class="important-small-blue">Approved Payments</span>';
        }
        return status;
    }

    formatLastLogin(cell, row) {
        return moment.utc(row.last_login).local().format('MMM Do YYYY, h:mm a');
    }

    formatJoinDate(cell, row) {
        return moment.utc(row.join_date).local().format('MMM Do YYYY, h:mm a');
    }

    flattenObject(ob) {
        var toReturn = {};
        for (var i in ob) {
            if (!ob.hasOwnProperty(i)) continue;
            if ((typeof ob[i]) == 'object') {
                var flatObject = this.flattenObject(ob[i]);
                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) continue;
                    toReturn[x] = flatObject[x];
                }
            } else {
                toReturn[i] = ob[i];
            }
        }
        return toReturn;
    }

    didSelectRow(row) {
        browserHistory.push('/admin/user/' + row.id);
    }

    handleCloseModal(e) {
        this.setState({
            showModal: !this.state.showModal
        });
    }

    onExportUsersDataButtonClick() {
        this.setState({
            showModal: true
        })
    }

    handleExportTypeChange(e) {
        this.setState({
            exportType: e.target.value
        })
    }

    validateExportType() {
        if (this.state.exportType == "" || this.state.exportType == "default") {
            modal.showInfo("Please select an option!", "danger", "top", "center");
            return false
        }

        return true
    }

    exportUsersData() {
        if (!this.validateExportType()) {
            return;
        }
        
        adminUserAccounts.exportUsersData(this.state.exportType, function(response) {
            modal.showInfo("Your exported data will be downloaded shortly!", "success", "top", "center");
        })
    }

    render(){
        var self = this;
        var userAccounts = this.state.userAccounts;
        const showModal = this.state.showModal;

        if(userAccounts !== null) {
            userAccounts = this.state.userAccounts.map(function(account) {
                return self.flattenObject(account);
            });
        }

        var options = {}
        if (window.innerWidth < 992) {
            options = {
                onRowClick: this.didSelectRow,
            };
        } else {
            options = {
                onRowClick: this.didSelectRow,
                defaultSortName: 'join_date',
                defaultSortOrder: 'desc'
            };
        }

        return (
            <div class="row">
                <div class="col-md-12">
                    <div class="content">
                        {userAccounts != null ? (
                            window.innerWidth < 992 ? (
                            <BootstrapTable data={userAccounts} version='4' striped search pagination options={options}>
                                <TableHeaderColumn dataField='id' width="30" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                <TableHeaderColumn dataField='firstname' dataFormat={this.formatName} dataSort={ true }>Name</TableHeaderColumn>
                                <TableHeaderColumn dataField='subscription' dataSort={ true }>Subscription</TableHeaderColumn>
                                <TableHeaderColumn dataField='user_type' dataFormat={this.formatUserType} dataSort={ true }>Account Type</TableHeaderColumn>
                                <TableHeaderColumn dataAlign='center' width="70" dataFormat={this.formatActionOptions.bind(this)}></TableHeaderColumn>
                            </BootstrapTable>
                            ) : (
                            <BootstrapTable data={userAccounts} version='4' striped search pagination options={options}>
                                <TableHeaderColumn dataField='id' width="50" dataFormat={this.formatIndexColumn} hidden={window.matchMedia('(max-width: 992px)').matches} isKey={ true }></TableHeaderColumn>
                                <TableHeaderColumn dataField='firstname' dataFormat={this.formatName} dataSort={ true }>Name</TableHeaderColumn>
                                <TableHeaderColumn dataField='username' dataSort={ true }>Username</TableHeaderColumn>
                                <TableHeaderColumn dataField='company' dataFormat={this.formatCompany} dataSort={ true }>Company</TableHeaderColumn>
                                <TableHeaderColumn dataField='phone' dataSort={ true }>Phone</TableHeaderColumn>
                                <TableHeaderColumn dataField='status' dataFormat={this.formatBilling} dataSort={ true }>Status</TableHeaderColumn>
                                <TableHeaderColumn dataField='subscription' dataSort={ true }>Subscription</TableHeaderColumn>
                                <TableHeaderColumn dataField='user_type' dataFormat={this.formatUserType} dataSort={ true }>Account Type</TableHeaderColumn>
                                <TableHeaderColumn dataField='last_login' dataFormat={this.formatLastLogin} dataSort={ true }>Last Login</TableHeaderColumn>
                                <TableHeaderColumn dataField='join_date' dataFormat={this.formatJoinDate} dataSort={ true }>Date Created</TableHeaderColumn>
                                <TableHeaderColumn dataAlign='center' width="150" dataFormat={this.formatActionOptions.bind(this)}></TableHeaderColumn>
                            </BootstrapTable>
                            )
                        ) : (
                            <p>No users yet.</p>
                        )}
                    </div>
                    <div class="content" style={{float: "right"}}>
                        <Modal
                            isOpen={showModal}
                            onRequestClose={this.handleCloseModal.bind(this)}
                            style={modalStyles.getModalStyles()}
                            ariaHideApp={false}
                        >
                            <div class="row">
                                <div class="modal-exit-icon pull-right" onClick={this.handleCloseModal.bind(this)}></div>
                            </div>
                            <div class="row">
                                <div class="modal-header">Export Users Data</div>
                            </div>
                            <div class="row">
                                <div class="col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-group">
                                        <label for="export_type">Choose the subscription plan you want to export users from:</label>
                                        <div class="clearfix"></div>
                                        <div class="col-md-6 col-sm-6 col-xs-12">
                                            <select class="form-control" onChange={this.handleExportTypeChange.bind(this)}>
                                                <option value="default">Select an option</option>
                                                <option value="free">Free</option>
                                                <option value="premium">Premium</option>
                                                <option value="enterprise">Enterprise</option>
                                                <option value="all">All Plans</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                            <div class="row">
                                <div class="col-md-8 col-md-offset-4 col-sm-8 col-sm-offset-4 col-xs-8 col-xs-offset-3">
                                    <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.exportUsersData.bind(this)}>
                                        Export Data
                                    </button>
                                </div>
                            </div>
                        </Modal>
                        <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.onExportUsersDataButtonClick.bind(this)}>
                            Export Users Data
                        </button>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Admin/Users/UsersTable.jsx